/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendD2TimeseriesResponseDto } from '../models/backend-d-2-timeseries-response-dto';
import { getTimeseriesEndpointDashboardsD2TimeseriesGet } from '../fn/dashboards/get-timeseries-endpoint-dashboards-d-2-timeseries-get';
import { GetTimeseriesEndpointDashboardsD2TimeseriesGet$Params } from '../fn/dashboards/get-timeseries-endpoint-dashboards-d-2-timeseries-get';

@Injectable({ providedIn: 'root' })
export class BackendApiD2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTimeseriesEndpointDashboardsD2TimeseriesGet()` */
  static readonly GetTimeseriesEndpointDashboardsD2TimeseriesGetPath = '/dashboards/d2/timeseries';

  /**
   * D2 ФОТ: помесячная динамика плановых зарплат, разбитая по типам персонала.
   *
   * Каждый item — один месяц, внутри items[].groups всегда три записи (Производственный/Торгово-коммерческий/Управленческий), нули там, где данных нет. Учитываются ВСЕ строки opex_salary включая is_blocked. Индексация и налоги не применяются — см. docs/dashboards/d2.md.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTimeseriesEndpointDashboardsD2TimeseriesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTimeseriesEndpointDashboardsD2TimeseriesGet$Response(
    params: GetTimeseriesEndpointDashboardsD2TimeseriesGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendD2TimeseriesResponseDto>> {
    return getTimeseriesEndpointDashboardsD2TimeseriesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D2 ФОТ: помесячная динамика плановых зарплат, разбитая по типам персонала.
   *
   * Каждый item — один месяц, внутри items[].groups всегда три записи (Производственный/Торгово-коммерческий/Управленческий), нули там, где данных нет. Учитываются ВСЕ строки opex_salary включая is_blocked. Индексация и налоги не применяются — см. docs/dashboards/d2.md.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTimeseriesEndpointDashboardsD2TimeseriesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTimeseriesEndpointDashboardsD2TimeseriesGet(
    params: GetTimeseriesEndpointDashboardsD2TimeseriesGet$Params,
    context?: HttpContext,
  ): Observable<BackendD2TimeseriesResponseDto> {
    return this.getTimeseriesEndpointDashboardsD2TimeseriesGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendD2TimeseriesResponseDto>): BackendD2TimeseriesResponseDto => r.body),
    );
  }
}
